import { createFileRoute } from '@tanstack/react-router'

import { EditLineItemPage } from '@/pages/line-items/[id]/edit/EditLineItemPage'

export const Route = createFileRoute('/_authenticated/_dashboard/line-items/$id/edit/')({
  component: EditLineItemPage,
})
